import { useState, useEffect } from 'react';
import { projectsApi } from '../../../services/api';
import { logger } from '../../../utils/logger';

interface HistoryTabProps {
  projectId: string;
}

export function HistoryTab({ projectId }: HistoryTabProps) {
  const [changeHistory, setChangeHistory] = useState<unknown[]>([]);
  const [loadingHistory, setLoadingHistory] = useState(false);

  useEffect(() => {
    const loadChangeHistory = async () => {
      setLoadingHistory(true);
      try {
        const history = await projectsApi.getChangeHistory(projectId);
        setChangeHistory(history);
      } catch (err) {
        logger.error('Failed to load change history:', err);
      } finally {
        setLoadingHistory(false);
      }
    };

    loadChangeHistory();
  }, [projectId]);

  return (
    <div className="space-y-2">
      {loadingHistory ? (
        <div className="text-center py-8">
          <div className="animate-spin text-2xl">⏳</div>
        </div>
      ) : changeHistory.length === 0 ? (
        <div className="text-center py-8 text-muted-foreground">
          <div className="text-4xl mb-3">📜</div>
          <p>No change history yet</p>
        </div>
      ) : (
        changeHistory.map((record: unknown, idx: number) => {
          const r = record as { action: string; timestamp: string; details: string; user: string; documentNumber?: string };
          return (
            <div
              key={idx}
              className={`p-3 rounded-lg ${
                idx % 2 === 0
                  ? 'bg-muted'
                  : 'bg-card'
              }`}
            >
              <div className="flex justify-between items-start gap-2 mb-1">
                <span className="text-sm font-medium text-foreground">
                  {r.action.replace(/_/g, ' ').toUpperCase()}
                </span>
                <span className="text-xs text-muted-foreground">
                  {new Date(r.timestamp).toLocaleString()}
                </span>
              </div>
              <p className="text-sm text-foreground">
                {r.details}
              </p>
              <div className="mt-1 text-xs text-muted-foreground">
                By: {r.user}
                {r.documentNumber && (
                  <span> • Doc: {r.documentNumber}</span>
                )}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
